import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceInsights', [
    'loading',
    'cachedDeviceEvents',
    'cachedDeviceConditions',
    'cachedDeviceCycles',
    'cachedDeviceActivities',
    'cachedDeviceStateAggregateHour',
    'cachedDeviceStateAggregateHourDevice',
    'cachedDeviceCycleByDevice',
    'cachedDeviceInsights',
    'cachedDeviceInsightsDevice',
    'cachedDeviceInsightsWithFilters',
    'changedDeviceActivities',
    'changedDeviceActivitiesAsObjectArray',
  ]),
}

export const Methods = mapActions('deviceInsights', [
  'getDeviceStateAggregateHour',
  'getDeviceCycleByDevice',
  'getDeviceEvents',
  'getDeviceInsights',
  'changeDeviceActivities',
  'doInsightsLogin',
])
